import { useState } from 'react';
import SelectionPanelOptionButton from 'automation-ui-canvas/create/SelectionPanelOptionButton';
import CustomExpandableSection from 'automation-ui-canvas/components/common/CustomExpandableSection';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SelectionPanelGroup({
  group: {
    text,
    options
  },
  hasSearchTerm,
  onSelectOption
}) {
  const [isOpen, setIsOpen] = useState(true);
  return /*#__PURE__*/_jsx(CustomExpandableSection, {
    title: text,
    titleProps: {
      padding: '300',
      marginBlock: '50'
    },
    caretSpaceProps: {
      marginInlineEnd: '300'
    },
    renderContent: () => options.map(option => /*#__PURE__*/_jsx(SelectionPanelOptionButton, {
      option: option,
      onClick: () => onSelectOption(option)
    }, option.value)),
    open: isOpen || hasSearchTerm,
    onOpenChange: ({
      target: {
        value
      }
    }) => {
      setIsOpen(value);
    }
  });
}